import React from "react";
import { Box, Link } from "@mui/material";
import { useGenericActivityFromElysiumMutation } from "src/api/client/generic-activity-from-elysium.api";
import { EnumActivityType } from "src/api/client/generic-activity.api";
import { IconAvatar } from "src/components/icons";
import { useNewsTicker } from "src/components/layout/news-ticker/use-news-ticker";
import { ITickerConfig, TickerText } from "src/components-mui/common/ticker-text/ticker-text";

export const NEWS_TICKER_TEST_ID = "news-ticker";

const MAX_ARTICLE_NAME_WIDTH = ["32ch", "50ch", "81ch"];

const NEWS_TICKER_BASE_CONFIG: ITickerConfig = {
    animationStyle: "full-viewport",
    alwaysAnimate: true,
    speed: 55,
};

export const NewsTicker = () => {
    const { newsReactions, onAllItemsShown } = useNewsTicker();
    const genericActivity = useGenericActivityFromElysiumMutation();

    const onClick = (traderId?: string, url?: string) => () => {
        genericActivity({
            activityTypeId: EnumActivityType.NavigationClicked,
            parameter: JSON.stringify({
                type: "ticker",
                traderId,
                targetUrl: url,
            }),
            referrer: window.location.href,
        });
    };

    const hasItems = newsReactions && newsReactions.length > 0;

    return (
        <React.StrictMode>
            <Box
                role="group"
                data-test-id={NEWS_TICKER_TEST_ID}
                aria-hidden
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: "appBar",
                    height: theme => theme.spacing(4),
                    backgroundColor: "green.100",
                }}
            >
                {hasItems && (
                    <TickerText
                        config={{
                            ...NEWS_TICKER_BASE_CONFIG,
                            onAnimationIteration: onAllItemsShown,
                        }}
                        sx={{ height: "100%", width: "100%", display: "flex", alignItems: "center", pl: 2 }}
                        textSx={{ gap: "10vw", fontSize: "sm" }}
                    >
                        {newsReactions.map((currentItem, idx) => (
                            <Box key={`${currentItem.url}-${idx}`} component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
                                <Box component="span">
                                    „
                                    <Link
                                        tabIndex={-1}
                                        href={currentItem.url}
                                        onClick={onClick(currentItem.trader?.id, currentItem.url)}
                                        sx={{
                                            display: "inline-block",
                                            verticalAlign: "bottom",
                                            maxWidth: MAX_ARTICLE_NAME_WIDTH,
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {currentItem.title}
                                    </Link>
                                    &rdquo;
                                </Box>

                                {currentItem.trader && currentItem.interaction ? (
                                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                                        <IconAvatar />
                                        <Box component="span">
                                            {currentItem.trader.firstName} {currentItem.trader.lastName}
                                        </Box>
                                        <Box component="span">{currentItem.interaction}</Box>
                                    </Box>
                                ) : null}
                            </Box>
                        ))}
                    </TickerText>
                )}
            </Box>
        </React.StrictMode>
    );
};
